<template>
  <v-layout>
    <CaseSLANotification></CaseSLANotification>
    <v-flex xs12 pb-0 mb-0>
      <v-spacer class="mt-4 pt-4 hidden-md-and-up"></v-spacer>
     <v-card
          flat
          color="transparent"
          class="mb-4"
        >
        <v-flex tag="h1" id="title-bar" xs12 class="pb-1" :class="{'page-header-fab-padding': $vuetify.breakpoint.mdAndUp}">
          <PageTitle id="case-title" :pageTitle="pageTitle"></PageTitle>
        </v-flex>
        <v-tooltip v-if="notificationsEnabled" left color="secondary">
          <font-awesome-icon
            slot="activator"
            class="primary--text ma-0"
            size="lg"
            icon="bullhorn"
            style="margin-top:12px !important; float:right">
          </font-awesome-icon>
          <span>You're listening to this case</span>
        </v-tooltip>
        <h4 class="pt-1" id="case-type" style="display:inline-block; height:0px;">
          Template:
          <span class="font-weight-bold pr-4">{{caseTypeName}}</span>
        </h4>
        <h4 style="display:inline-block; height:0px;">
          Status:
          <span id="case-state" class="font-weight-bold pr-4">{{state}}</span>
        </h4>
        <h4 style="display:inline-block; height:0px; " v-if="this.hasActiveServiceLevel">
          Service Levels:
          <span id="case-state" class="font-weight-bold pr-3">
            {{this.serviceLevels.length}}
            <v-tooltip top :color="slaColour">
              <v-btn icon class="ml-0 mr-0" slot="activator" @click="SLADialog = true">
                <v-icon style="margin-bottom:2px; vertical-align:middle" color="error">notifications_active</v-icon>
              </v-btn>
              <span>{{overdueSlas}}</span>
            </v-tooltip>
            <!-- This icon displays if an SLA is overdue. If no overdue but one in jeopardy it will be color="tertiary"-->
          </span>
        </h4>
        <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
          <v-btn
            flat
            slot="activator"
            icon
            class="ma-0 mr-0 pa-0"
            dark
            color="secondary"
            style="margin-top:-3px !important; margin-left:-10px !important;padding-right:15px;"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile v-if="!isBookmarked" @click="createBookmark()">
              <v-icon class="mr-2" color="secondary">bookmark</v-icon>Bookmark this case
            </v-list-tile>
            <v-list-tile v-if="isBookmarked" @click="removeBookmark()">
              <v-icon class="mr-2" color="secondary">bookmark</v-icon>Remove bookmark
            </v-list-tile>
          </v-list>
        </v-menu>
        <case-presence-display :viewers="viewers" :viewerMax="viewerMax"></case-presence-display>
        <v-dialog v-model="SLADialog" width="400">
          <v-card class="pa-4">
            <v-card-title class="ma-0 mb-2 pa-0">
              <h2 class="mb-2">Service Levels</h2>
            </v-card-title>
            <div>
              <v-flex xs12  v-for="(serviceLevel, index) in serviceLevels" :key="index">
                <div>
                  <v-flex v-if="serviceLevel.breachedAt" xs12 d-block class="mb-2">
                    <h3 class="font-weight-bold error--text">
                      <v-icon
                        size="21" color="error" class="ma-0 mr-2 mt-1"
                        style="vertical-align:top">
                        notifications_active
                      </v-icon>
                        {{slaName(serviceLevel)}}
                    </h3>
                    <h4 class="error--text ml-4 pl-2">In breach for {{getDuration(serviceLevel.breachedAt)}}.</h4>
                  </v-flex>

                  <v-flex v-if="serviceLevel.jeopardizedAt && !serviceLevel.breachedAt" xs12 d-block class="mb-2">
                    <h3 class="font-weight-bold tertiary--text">
                      <v-icon
                        size="21" color="tertiary" class="ma-0 mr-2 mt-1"
                        style="vertical-align:top">
                        notifications_active
                      </v-icon>
                      {{slaName(serviceLevel)}}
                    </h3>
                    <h4 class="tertiary--text ml-4 pl-2">In Jeopardy for {{getDuration(serviceLevel.jeopardizedAt)}}.</h4>
                  </v-flex>

                  <v-flex v-if="!serviceLevel.jeopardizedAt && !serviceLevel.breachedAt" xs12 d-block class="mb-2">
                    <h3 class="font-weight-bold secondary--text">
                      <v-icon
                        size="21" color="secondary" class="ma-0 mr-2 mt-1"
                        style="vertical-align:top">
                        notifications_active
                      </v-icon>
                      {{slaName(serviceLevel)}}
                    </h3>
                  </v-flex>
                </div>
              </v-flex>
            </div>
            <v-card-actions class="ma-0 mt-3 pa-0">
              <v-btn @click="SLADialog = false" color="error">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue"
import CasePresenceDisplay from "@/components/shared/CasePresenceDisplay"
import CaseSLANotification from "@/components/cases/CaseSlaNotification"
import Helpers from "@/helpers.js"
import { mapState } from "vuex"

export default {
  name: "case-header",
  data: () => ({
    SLADialog: false,
    flagged: false,
    schemaView: "default",
    sections: [],
    viewerMax: 3,
    viewerMin: 3
  }),
  components: { PageTitle, CasePresenceDisplay, CaseSLANotification },
  computed: {
    ...mapState({
      cbroute: state => state.cbroute,
      caseTypeName: state => Helpers.caseTypeName(state.caseTypes.current),
      caseTypes: state => state.caseTypes.all,
      isBookmarked: state => state.cases.currentlySelected.bookmarked,
      currentCase: state => state.cases.currentlySelected.case,
      subscriptions: state => state.currentUser.subscriptions,
      viewers: state => state.cases.currentlySelected.viewers,
      currentUserId: state => state.currentUser.me.id,
      isLoading: state => state.cases.currentlySelected.loading,
      bookmarks: state =>
        state.ui.caseWorkMenu &&
        state.ui.caseWorkMenu[0].items &&
        state.ui.caseWorkMenu[0].items[0] &&
        state.ui.caseWorkMenu[0].items[0].childItems &&
        state.ui.caseWorkMenu[0].items[0].childItems
          ? state.ui.caseWorkMenu[0].items[0].childItems
          : []
    }),
    caseViewers() {
      if (this.viewers && this.viewers.length > 1) {
        const all = this.viewers.filter(viewer => viewer.id !== this.currentUserId) // Excluding current user
        return all.slice(0, this.viewerMax)
      } else {
        return []
      }
    },
    caseViewerOverflowCount() {
      if (this.viewers && this.viewers.length > this.viewerMax) {
        return this.viewers.length - this.viewerMax - 1 // Excluding current user
      } else {
        return 0
      }
    },
    caseId() {
      return this.cbroute.params.case_id
    },
    hasServiceLevels() {
      return this.serviceLevels && this.serviceLevels.length > 0
    },
    hasActiveServiceLevel() {
      if (this.hasServiceLevels) {
        const actives = this.serviceLevels.filter((sla) => sla.active)
        return actives.length > 0
      } else {
        return false
      }
    },
    pageTitle() {
      if (this.currentCase) {
        return this.currentCase.title
      } else {
        return "TITLE "
      }
    },
    serviceLevels() {
      if (this.currentCase) {
        if (this.currentCase.serviceLevels) {
          return this.currentCase.serviceLevels
        }
      }
      return []
    },
    state() {
      if (this.currentCase) {
        return this.currentCase.currentState
      } else {
        return "STATE"
      }
    },
    flagColor() {
      if (this.flagged) {
        return "success"
      } else {
        return "grey darken-1"
      }
    },
    notificationsEnabled() {
      const subs = this.subscriptions.filter((sub) => sub.caseId === this.caseId)
      return (subs && subs.length && subs.length > 0)
    },
    overdueSlas() {
      let result = "Service Level Agreements"
      if (this.serviceLevels) {
        let count = 0
        this.serviceLevels.forEach(sla => {
          if (sla.jeopardizedAt || sla.breachedAt) { count++ }
        })
        if (count > 0) { result = count + " Overdue SLA" }
      }
      return result
    },
    slaColour() {
      let result = "primary"
      if (this.serviceLevels) {
        let jeopardy = 0
        let breach = 0
        this.serviceLevels.forEach(sla => {
          if (sla.jeopardizedAt) { jeopardy++ }
          if (sla.breachedAt) { breach++ }
        })

        if (jeopardy > 0) { result = "tertiary" }
        if (breach > 0) { result = "error" }
      }
      return result
    },
    orderedHeaders() {
      const fieldsets = []
      if (this.currentCase === null || this.currentCase === undefined) {
        return []
      }
      if (
        this.currentCase.schema === null ||
        this.currentCase.schema === undefined
      ) {
        return []
      }
      if (this.currentCase.schema.case_data_views) {
        this.currentCase.schema.case_data_views.edit.rows.forEach(function(
          row
        ) {
          row.columns.forEach(function(column) {
            fieldsets.push(column.fieldset)
          })
        })
      } else {
        this.currentCase.schema.fieldsets.forEach(function(header) {
          fieldsets.push(header.name)
        })
      }
      return fieldsets
    }
  },
  mounted() {
    this.onResize()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    async createBookmark() {
      const result = await this.$store.dispatch("createBookmark", {
        route: this.cbroute.path,
        linkText: this.pageTitle
      })
      if (result) {
        this.$store.commit("setCaseBookmarked", true)
      }
    },
    async removeBookmark() {
      let id
      this.bookmarks.forEach(bookmark => {
        if (bookmark.route === this.cbroute.path) {
          id = bookmark.id
        }
      })
      if (id > 0) {
        const result = await this.$store.dispatch("deleteBookmark", { id })
        if (result) {
          this.$store.commit("setCaseBookmarked", false)
        }
      } else {
        this.$store.commit("displayFlashMessage", {
          message: "ID not found, cannot delete..",
          severity: "error"
        })
      }
    },
    slaName(serviceLevel) {
      if (serviceLevel && serviceLevel.serviceLevelCriteria && serviceLevel.serviceLevelCriteria.name) {
        return serviceLevel.serviceLevelCriteria.name
      }
      return "Untitled Service Level"
    },
    getDuration(fromDate) {
      return Helpers.calculateTimeDifferenceFromNow(fromDate)
    },
    onResize() {
      let max
      if (this.$vuetify.breakpoint.smAndDown) {
        max = Math.floor(window.innerWidth / 100) + 2 // Mobile max
      } else {
        max = Math.floor(window.innerWidth / 100) - 10 // Desktop max
      }
      if (this.viewerMax !== max) {
        if (max >= this.viewerMin) {
          this.viewerMax = max
        } else {
          this.viewerMax = this.viewerMin
        }
      }
    }
  }
}
</script>
<style>
.case-header-sla {
  z-index:1;
  cursor:pointer;
  -webkit-border-bottom-right-radius: 55px;
  -moz-border-radius-bottomright: 55px;
  border-bottom-right-radius: 55px;
  width:45px;
  height:45px;
  position:absolute;
  top:-48px;
  left:-48px;
}

.case-header-sla.breach {
  background: #db444d;
  background: -webkit-gradient(linear, left top, left bottom, from(#db444d), to(#af1f2e));
  background: linear-gradient(to bottom, #db444d 0%, #af1f2e 100%);
}

  .case-header-sla.jeopardy {
     background: #e9a916;
    background: -webkit-gradient(linear, left top, left bottom, from(#e9a916), to(#db7800));
    background: linear-gradient(to bottom, #e9a916 0%, #db7800 100%);
  }

.case-header-sla.mobile {
  left:initial;
  right:-24px;
  top:32px;
  -webkit-border-bottom-right-radius: 0px;
  -moz-border-radius-bottomright: 0px;
  border-bottom-right-radius: 0px;
  -webkit-border-bottom-left-radius: 55px;
  -moz-border-radius-bottomleft: 55px;
  border-bottom-left-radius: 55px;
}

.case-header-sla-icon {
  position:absolute;
  bottom:15px;
  right:17px;
  vertical-align:middle;
}

.case-header-sla.mobile .case-header-sla-icon {
  position:absolute;
  bottom:15px;
  right:7px;
}
</style>
